<template>
  <div :class="`card card-link ${size} ${type}`" v-on:click="onClick()" :data-href="data.url">
    <v-lazy-image
        :src="data.image || 'https://via.placeholder.com/500.png?text=' + encodeURIComponent(data.title)"
        src-placeholder="https://www.brownweinraub.com/wp-content/uploads/2017/09/placeholder.jpg"
    />
    <div class="text-wrapper">
      <div class="text-inner">
        <span class="author" v-if="data.author">{{ data.author }}</span>
        <h1>{{ stripHtml(data.title) }}</h1>
        <span class="summary" v-if="data.summary">{{ stripHtml(data.summary) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VLazyImage from "v-lazy-image";

export default {
  components: { VLazyImage },
  props: [ "size", "data", "type"],
  methods: {
    stripHtml(html){
      const tempText = document.createElement("div");
      tempText.innerHTML = html;
      return tempText.textContent || tempText.innerText || "";
    },
    onClick() {
      if (this.data.url.startsWith('http')) {
        this.$impressions.externalClick('app_card_click_' + this.type, this.data.url)
      } else {
        console.log(this.data.url)
        this.$impressions.sendEvent('app_card_click_' + this.type, this.data.url)
        this.$router.push(this.data.url);
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import "../styles/variables"

  .card-link
    margin-bottom: 15px
    cursor: pointer
    transition: box-shadow 200ms linear
    overflow: hidden
    border-radius: 3px

    &.search
      .text-wrapper
        vertical-align: middle !important
        height: unset !important

    &:hover
      box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, .25)

    img
      max-height: 100%
      object-position: center
      object-fit: cover
      box-sizing: border-box
      border: 1px solid rgba(0,0,0,0.05)
      border-radius: 3px

    &.small
      height: 10vh
      min-height: 100px

      img
        display: inline-block
        vertical-align: middle
        margin: 3px
        height: calc(100% - 6px)
        width: 130px

      .text-wrapper
        position: relative
        display: inline-block
        vertical-align: middle
        margin: 4px
        height: 92px
        overflow: hidden
        width: calc(100% - 160px)

        h1
          display: block
          overflow: hidden
          margin: 0 0 2px 0
          font: 600 16px/19px $font-serif
          max-height: 38px
          color: #444

        .summary
          display: block
          overflow: hidden
          font: 400 12px/15px $font-sansSerif
          max-height: 30px
          color: #777

        .author
          position: absolute
          left: 0
          bottom: 0
          display: block
          overflow: hidden
          font: 700 10px/16px $font-sansSerif
          max-height: 32px
          color: #999

    &.medium
      height: 25vh
      min-height: 250px

      img
        margin: 3px
        height: calc(100% - 6px)
        width: calc(100% - 6px)

      .text-wrapper
        display: flex
        position: absolute
        right: 5px
        bottom: 5px
        left: 5px
        height: 150px
        width: calc(100% - 10px)
        background: linear-gradient(180deg, transparent, rgba(0,0,0,0.8))

        .text-inner
          align-self: flex-end
          padding: 5px 10px

          h1
            display: block
            overflow: hidden
            margin: 0 0 3px 0
            font: 600 20px/28px $font-serif
            max-height: 56px
            color: #fff

          .summary
            display: block
            overflow: hidden
            margin: 0 0 3px 0
            font: 400 14px/18px $font-sansSerif
            max-height: 36px
            color: #e2e2e2

        .author
          display: block
          overflow: hidden
          margin: 0 0 2px 0
          font: 700 12px/16px $font-sansSerif
          max-height: 32px
          color: #eee


    &.large
      height: 40vh
      min-height: 400px

      img
        margin: 3px
        height: calc(100% - 6px)
        width: calc(100% - 6px)

      .text-wrapper
        display: flex
        position: absolute
        right: 5px
        bottom: 5px
        left: 5px
        height: 200px
        width: calc(100% - 10px)
        background: linear-gradient(180deg, transparent, rgba(0,0,0,0.8))

        .text-inner
          align-self: flex-end
          padding: 5px 10px

          h1
            display: block
            overflow: hidden
            margin: 0 0 3px 0
            font: 600 28px/32px $font-serif
            max-height: 64px
            color: #fff

          .summary
            display: block
            overflow: hidden
            margin: 0 0 3px 0
            font: 400 16px/22px $font-sansSerif
            max-height: 44px
            color: #e2e2e2

        .author
          display: block
          overflow: hidden
          margin: 0 0 2px 0
          font: 700 12px/16px $font-sansSerif
          max-height: 32px
          color: #eee

</style>